import { HttpSDK, HITL } from '@/api';
import { useHelpers } from './use-helpers';
import { useAuth } from './use-auth';

export const useHttpSDK = () => {
  const { getToken } = useAuth();
  const {
    contactsURL,
    dataHubURL,
    mediaURL,
    filesApiUrl,
    httpGatewayUrl,
    hitlApiURL,
    hitlEKSApiURL,
    providersAccountId,
    sdkApiUrl,
    serviceDiscoveryURL,
    usersURL,
  } = useHelpers();

  const initializeHttpSDKs = () => {
    HITL.initialize({
      token: getToken,
      hitlUrl: hitlApiURL.value,
      hitlEksUrl: hitlEKSApiURL.value,
      discoveryUrl: serviceDiscoveryURL.value,
    });

    HttpSDK.initialize({
      token: getToken,
      contactsURL: contactsURL.value,
      dataHubURL: dataHubURL.value,
      mediaURL: mediaURL.value,
      httpGatewayURL: httpGatewayUrl.value,
      filesURL: filesApiUrl.value,
      providersAccountId: providersAccountId.value,
      sdkURL: sdkApiUrl.value,
      serviceDiscoveryURL: serviceDiscoveryURL.value,
      usersURL: usersURL.value,
    });
  };

  return { initializeHttpSDKs };
};
